import React from 'react';
// import customTheme from '../../theme';
import styled from 'styled-components';

const ErrorBox = styled.div`
  margin: 9.5px 0 0 0;
  padding: 8.4px 11px 7.6px 12px;
  border-radius: 3px;
  background-color: #faeb8c;
  width: 100%;
  display: flex;
  font-size: 10px;
  font-weight: bold;
  @media screen and (max-width: 640px) {
    text-align: center;
  }
`;

export const Error: React.FC = ({ children }) => {
  return (
    <ErrorBox>
      <div>{children}</div>
    </ErrorBox>
  );
};
